/** Shown when a chapter has no right or wrong answers yet. */
export const UNANSWERED_PERCENT = '\u2013';

/**
 * Whole-number percent correct among answered questions:
 * Richtig / (Richtig + Falsch) * 100.
 * Unanswered questions are ignored. Nothing answered yields an en dash.
 */
export function formatCorrectPercent(
  correct: number | null | undefined,
  wrong: number | null | undefined
): string {
  const right = countOrZero(correct);
  const incorrect = countOrZero(wrong);
  const answered = right + incorrect;
  if (answered === 0) {
    return UNANSWERED_PERCENT;
  }
  return Math.round((right / answered) * 100) + '%';
}

function countOrZero(value: number | null | undefined): number {
  const count = Number(value);
  if (!isFinite(count) || count <= 0) {
    return 0;
  }
  return count;
}
